import React, { useMemo } from 'react';
import { Box, FormGroup, IconButton, InputAdornment } from '@mui/material';
import { DebouncedInputUI, InputUI } from '../Interface';
import ClearIcon from '@mui/icons-material/Clear';

const GanttFilter = ({ initial, searchQuery, onSearchChange }) => {
  const { initialState, setInitialState } = initial;

  const handleFilterChange = (field, value, id = null, operator) => {
    setInitialState((prev) => {
      let newItems = prev.filter.filterModel.items.filter((item) => item.field !== field);

      if (value !== null && value !== '') {
        newItems.push({
          id,
          field,
          operator: operator ?? 'is',
          value,
        });
      }

      return {
        ...prev,
        filter: {
          filterModel: {
            items: newItems,
            logicOperator: 'and',
          },
        },
      };
    });
  };

  return (
    <FormGroup>
      <Box display="flex" alignItems="center" gap="0.5rem" flexWrap="wrap">
        <Box>
          <InputUI
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Feladat keresés…"
            size="small"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!!searchQuery && (
                    <IconButton
                      aria-label="Keresés törlése"
                      size="small"
                      edge="end"
                      onClick={() => onSearchChange('')}
                      tabIndex={-1}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <DebouncedInputUI
            size="small"
            placeholder="Projekt keresés…"
            debounceMs={800}
            variant="outlined"
            setQuickFilterSearchValue={(newValue) => {
              handleFilterChange('projectName', newValue, null, 'contains');
            }}
            quickFilterSearchValue={
              initialState?.filter?.filterModel?.items?.find((i) => i.field === 'projectName')?.value
            }
          />
        </Box>
      </Box>
    </FormGroup>
  );
};

export default GanttFilter;
